import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

export class TombOfAkhenatenGameAssets {

    public static INTRO_BACKGROUND: string = "resources/images/intro/introBackground.jpg";
    public static INTRO_LOGO: string = "resources/images/intro/introLogo.png";
    public static INTRO_FEATURE_1 = "resources/images/intro/Feature1/StickyWinSpins.png";
    public static INTRO_FEATURE_2 = "resources/images/intro/Feature2/AkhenatenSpins.png";
    public static INTRO_FEATURE_3 = "resources/images/intro/Feature3/PyramidWilds.png";
    public static INTRO_DIVIDER = "resources/images/intro/Intro_Divider.png";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static BONUS_GAME_BACKGROUND:string = "fsBackground";
    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("bonusGameMultiplierFont", "fonts/bitmapfonts/bonusGameMultiplierFont.fnt"),
                    new BitmapFontAsset("bonusGameMultiplierFontGlow", "fonts/bitmapfonts/bonusGameMultiplierFontGlow.fnt"),
                    new BitmapFontAsset("centerBigMultiplier", "fonts/bitmapfonts/centerBigMultiplier.fnt"),
                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json")
                ],
                animations : {
                    "horDivider" : "reelDivider/horizontal",
                    "verDivider" : "reelDivider/vertical"
                }
            }
        ],

        main : [
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                ],
                animations : {
                    "spinsShadow": "spinsShadow",
                    "243ways" : "stonePresser/xways/243ways",
                    "1024ways" : "stonePresser/xways/1024ways",
                    "3125ways" : "stonePresser/xways/3125ways",
                    "243waysGlow" : "stonePresser/xways/243waysGlow",
                    "1024waysGlow" : "stonePresser/xways/1024waysGlow",
                    "3125waysGlow" : "stonePresser/xways/3125waysGlow",
                    "pulley" : "stonePresser/pulley",
                    "ropeTop" : "stonePresser/ropeTop",
                    "ropeBottom" : "stonePresser/ropeBottom",
                    "ropeAttached" : "stonePresser/ropeAttached",
                    "ropeExtention" : "stonePresser/ropeExtention",
                    "winAmountShadow": "winAmountShadow",
                    "stoneFlakes": "stonePresser/new stone animation/stone_animation/stone_animation_",
                    "smokeOut": "stonePresser/smoke/smoke_",
                    "smokeUp": "stonePresser/bottom smoke/bottom_smole_",
                    "multiplierUpInFS": "stonePresser/red fire/red fire_",
                    "waysSmashParticles": "stonePresser/Betlways expolde/BL01_",
                    "big_win_1": "bigWin/bw_1",
                    "big_win_2": "bigWin/bw_2",
                    "big_win_3": "bigWin/bw_3",
                    "big_win_4": "bigWin/bw_4",
                    "big_bg_1": "bigWin/bg_1",
                    "big_bg_2": "bigWin/bg_2",
                    "big_bg_3": "bigWin/bg_3",
                    "big_bg_4": "bigWin/bg_4",
                    "big_win_tint": "bigWin/tint",
                    "bigWinCoin0": "bigWin/rubyAndCoins/coins/silver/TOA_Silver Coin_",
                    "bigWinCoin1": "bigWin/rubyAndCoins/coins/gold/TOA_Gold Coin_",
                    "bigWinCoin2": "bigWin/rubyAndCoins/ruby/blue/TOA_BlueRuby_",
                    "bigWinCoin3": "bigWin/rubyAndCoins/ruby/red/TOA_RedRuby_",
                    "semiDimmedFire": "three fire/three_fire/green/green_fire_",
                    "winFire": "three fire/three_fire/green/green_fire_",
                }
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                ],
                animations : {
                    "mainBackground" : "mainBackground",
                    "fsBackground" : "freespinBackground",
                    "reelBackground": "reelFrame/reelBackground",
                }
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ]
            },
            {
                name : "symbolsYellow",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsYellow0", "sheets/symbolsYellow/symbolsYellow0.json")
                ]
            },
            {
                name : "symbolsBlue",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsBlue0", "sheets/symbolsBlue/symbolsBlue0.json")
                ]
            },
            {
                name : "symbolsGreen",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsGreen0", "sheets/symbolsGreen/symbolsGreen0.json")
                ]
            },
            {
                name: "blurSymbols",
                assets: [
                    new TextureAsset("blurSymbols0", "sheets/blurSymbols/blurSymbols0.json"),
                ]
            },
            {
                name : "highRes",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("highRes0", "sheets/highRes/highRes0.json"),
                ],
                animations: {
                    "multiplierFsBg": "red gemsstone with fire/red_gemstone_fire_",
                    "frameBlinkShine":"New_anticipation_animation/blink/Blink",
                    "pyramidCircleShine":"pyramidWildIcon/PyramidCircle_shine",
                    "pyramidGlow":"pyramidWildIcon/HotZoneShinePyramid",
                    "pyramid":"pyramidWildIcon/pyramid",
                    "pyramidShine":"pyramidWildIcon/pyramid_glow",
                    "ring":"pyramidWildIcon/ring",
                    "ringShine":"pyramidWildIcon/RingShine",
                    "hotZoneGlow":"pyramidWildIcon/HotZoneRed",
                    "hotZone":"pyramidWildIcon/HotZone",
                    "shadow":"pyramidWildIcon/shadow",
                    "sky":"pyramidWildIcon/sky",
                    "skyGlow":"pyramidWildIcon/HotZoneShineSky",
                    "x2Ring":"pyramidWildIcon/X2_ring",
                    "big_win_coins_1": "bigWin/coins_1",
                    "big_win_coins_2": "bigWin/coins_2",
                    "big_win_coins_3": "bigWin/coins_3",
                    "big_win_coins_4": "bigWin/coins_4",
                }
            },
            {
                name: "freespin",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json"),
                ],
                animations: {
                    "outroScroll": "outroScroll",
                }
            },
            {
                name: "normalRes",
                assets: [
                    new TextureAsset("normalRes0", "sheets/normalRes/normalRes0.json"),
                    new TextureAsset("normalRes1", "sheets/normalRes/normalRes1.json"),
                ],
                animations: {
                    "akhenatenSpins": "pngSeq/fsCelebration/AkhenatenSpins/spins_",
                }
            },
            {
                name: "jpegSeq",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("jpegSeq0", "sheets/jpegSeq/jpegSeq0.json"),
                    new TextureAsset("jpegSeq1", "sheets/jpegSeq/jpegSeq1.json"),
                    new TextureAsset("jpegSeq2", "sheets/jpegSeq/jpegSeq2.json"),
                    new TextureAsset("jpegSeq3", "sheets/jpegSeq/jpegSeq3.json"),
                    new TextureAsset("jpegSeq4", "sheets/jpegSeq/jpegSeq4.json"),
                    new TextureAsset("jpegSeq5", "sheets/jpegSeq/jpegSeq5.json"),
                    new TextureAsset("jpegSeq6", "sheets/jpegSeq/jpegSeq6.json"),
                    new TextureAsset("jpegSeq7", "sheets/jpegSeq/jpegSeq7.json"),
                    new TextureAsset("jpegSeq8", "sheets/jpegSeq/jpegSeq8.json"),
                ],
                animations: {
                    "finalPyramidAnticipationFrame":"New_anticipation_animation/1x1_anticipation/1x1_anticipation_",
                    "fullReelPyramidAnticipation":"New_anticipation_animation/anticipation/anticipation_",
                    "anticipationBlast":"New_anticipation_animation/Anticipation_blast/Anticipation_Blast_",
                    "loopFireAnticipation":"New_anticipation_animation/Loop_fire/loop_fire_anyicipation_",
                    "wildBlast": "wildBlast/wild blast_",
                    "hotZoneBlast":"HotZoneBlast/HotZoneBlast_",
                    "dust": "dust/dust_",
                }
            },
            {
                name: "reelArea",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("reelArea0", "sheets/reelArea/reelArea0.json"),
                ],
                animations: {
                    "reelFrame": "reelFrame/reelFrame",
                    "reelFrameGold": "reelFrame/reelFrameGold",
                    "fsLeftLandscape": "reelFrame/fsLeftLandscape",
                    "fsLeftPortrait": "reelFrame/fsLeftPortrait",
                    "stonePresser" : "reelFrame/stonePresser",
                }
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("fsZoomInSpine", "spines/fsZoomIn.json"),
                    new SpineAsset("fsZoomOutSpine", "spines/fsZoomOut.json"),
                    new SpineAsset("scrollBurnLeftSpine", "spines/inGame/scroll/scroll_burn_left_skeleton.json"),
                    new SpineAsset("scrollBurnRightSpine", "spines/inGame/scroll/scroll_right_burn_skeleton.json"),
                    new SpineAsset("fireBurnSpine", "spines/inGame/scroll/scroll_burn_fire_skeleton.json"),
                    new SpineAsset("frameAnticipationSpine", "spines/inGame/frameAnticipation.json"),

                    //bigWin Spines
                    new SpineAsset("bigWin_1_start", "spines/big wins/beautiful.json"),
                    new SpineAsset("bigWin_1_loop", "spines/big wins/beautiful_loop.json"),
                    new SpineAsset("bigWin_2_start", "spines/big wins/strongbull.json"),
                    new SpineAsset("bigWin_2_loop", "spines/big wins/strongbull_loop.json"),
                    new SpineAsset("bigWin_3_start", "spines/big wins/crowned.json"),
                    new SpineAsset("bigWin_3_loop", "spines/big wins/crowned_loop.json"),
                    new SpineAsset("bigWin_4_start", "spines/big wins/greatkingship.json"),
                    new SpineAsset("bigWin_4_loop", "spines/big wins/greatkingship_loop.json"),

                    //bonus or scatter
                    new SpineAsset("bonusCombinedSpine", "spines/bonus/5x3_combine_part.json"),
                    new SpineAsset("bonusAnticipationSpine", "spines/bonus/anticipetion_effect_bonus.json"),
                    new SpineAsset("bonusFrameBottomSpine", "spines/bonus/bottom_frame_bone.json"),
                    new SpineAsset("bonusCloudTopSpine", "spines/bonus/cloud_bonus.json"),
                    new SpineAsset("bonusCloudBottomSpine", "spines/bonus/cloud_bonus.json"),
                    new SpineAsset("bonusHandSpine", "spines/bonus/hands_bonus.json"),
                    new SpineAsset("bonusHeadSpine", "spines/bonus/head_bonus.json"),
                    new SpineAsset("bonusFrameShineSpine", "spines/bonus/side_frame_shine_bonus.json"),
                    new SpineAsset("bonusTextSpine", "spines/bonus/text_bonus.json"),
                    new SpineAsset("bonusWinBackgroundSpine", "spines/bonus/win_bonus.json"),
                    new SpineAsset("bonusIdle", "spines/bonus/bonus_idle.json"),

                    new SpineAsset("waysUpdateSpine", "spines/ways_animation.json"),
                    new SpineAsset("m1", "spines/M symbols/M1.json"),
                    new SpineAsset("m2", "spines/M symbols/M2.json"),
                    new SpineAsset("m3", "spines/M symbols/M3.json"),
                    new SpineAsset("m4", "spines/M symbols/M4.json"),
                    new SpineAsset("m5", "spines/M symbols/M5.json"),
                    new SpineAsset("lowSym", "spines/low symbols/low_symbols.json"),
                    //wild spines
                    new SpineAsset("bottom_frame_cut_part", "spines/Wild/bottom_frame_cut_part.json"),
                    new SpineAsset("bottom_part", "spines/Wild/bottom_part.json"),
                    new SpineAsset("wild_idle", "spines/Wild/wild_idle.json"),
                    new SpineAsset("wild_top_part", "spines/Wild/wild_top_part.json"),
                    new SpineAsset("wild_text", "spines/Wild/wild_text.json"),

                    //new SpineAsset("scorpio", "spines/scorpio.json"),
                    new SpineAsset("pyramidWild", "spines/W-2.json"),
                    // new SpineAsset("wild_icon_win_shine", "spines/wild_icon_win_shine.json"), // not used anywhere
                    new SpineAsset("Wild_toggle", "spines/Wild_toggle.json"),
                ]
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        } else if(stateName === "normal") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(TombOfAkhenatenGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }
}
